import React from "react";
import { VOTE_STATIC_PATH_V2 } from "@/api/staticPaths";
import { canv } from "@/canv/global";
import type { CardWidget } from "../types";
import style from "./cardResult.module.css";

export function CardResult({ widgetData }: { widgetData: CardWidget }) {
    return (
        <>
            <img
                src={`${canv.host}${VOTE_STATIC_PATH_V2}${getCardImage(widgetData.progress)}`}
                className={style.cardImage}
                alt="card"
            />
            <div className={style.cardText}>{widgetData.text}</div>
        </>
    );
}

export const getCardImage = (progress: number): string => {
    if (progress >= 0.8) return "cardDone.png";
    if (progress > 0.9) return "cardInWork.png";
    return "cardPlanned.png";
};
